import { defineMessages } from 'utils/intl';

export default defineMessages({
  heroTitle: 'Wierzymy, że IT może być „dla ludzi”',
  heroSubtitle:
    'Prowadzimy sprzedaż wyłącznie do firm i instytucji, co pozwala nam zagwarantować najwyższą jakość obsługi naszych partnerów.',
  firstSectionTitle:
    'Od {year} r. dostarczamy firmom i instytucjom publicznym sprzęt oraz usługi IT, pomagając zapewnić bezpieczeństwo i ciągłość działania infrastruktury.',
  firstSectionDescription:
    'Pomagamy w określeniu potrzeb, doborze i konfiguracji sprzętu IT, a następnie terminowo dostarczamy i implementujemy rozwiązanie.\n\nRealizujemy projekty od jednego do nawet kilku tysięcy urządzeń w odpowiedniej specyfikacji, uzgodnionym terminie i na ustalonych warunkach.\n\nKlienci cenią nas za profesjonalne doradztwo i świadczenie usług zgodnych z umową – bez względu na skalę zamówienia.',
  whyTrustTitle: 'Dlaczego miałbyś nam zaufać?',
  whyTrustSubtitle:
    'Zapewniamy firmom i instytucjom publicznym dostęp do sprawdzonych rozwiązań IT renomowanych producentów. Dostarczamy sprzęt z oficjalnych dystrybucji terminowo i zgodnie z umową.',
  startCocon: 'powstaje {name}, w branży IT jesteśmy wciąż od ponad {during} lat',
  dellowo: 'uruchamiamy nasz pierwszy sklep online, w e–commerce działamy już ponad {during} lat',
  clients: 'firm i instytucji skorzystało z naszej oferty i zostało zadowolonymi klientami',
  devices: 'sztuk sprzętu IT dostarczyliśmy naszym klientom w samym {year} roku',
});
